export const settingCertificateCustomField = 'CertificateCustomField';
export const settingApprovalStartDateOverride = 'CertificateStartDateOverride';
export const settingEmailNotificationSettings = 'EmailNotificationSettings'; // FIX ME
export const settingRejectionReason = 'CertificateRejectionReason';
export const settingRejectionLetterUrl = 'CertificateRejectionLetterURL';

export const settingCustomerCustomField = 'CustomerCustomField';

export const certificateUuidMarker = '<<CERTUUID>>';
export const editTokenMarker = '<<EDITTOKEN>>';

// EC Wizard Settings
export const settingECWFormPrecedence = 'FormPrecedence';
export const settingECWMultiJurisdictionFormPrecedence = 'MultiJurisdictionFormPrecedence';
export const settingECWFormUpload = 'FormUpload';
export const settingECWProductQuestion = 'ProductQuestion';
export const settingECWStatutoryExemptCustomers = 'StatutoryExemptCustomers';
export const settingECWCertificateScope = 'CertificateScope';
export const settingECWProductListingPage = 'ProductListingPage';
export const settingECWAdditionalDocumentation = 'AdditionalDocumentation';

// Session Storage
export const sessionStorageECWizardExemptionTypes = 'ECWizard-ExemptionTypes';
export const sessionStorageECWizardJurisdictions = 'ECWizard-Jurisdictions';
